import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export function useFetch(url) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  useEffect(() => {
    let alive = true;
    setData(null);
    setError(null);
    api.get(url).then((r) => alive && setData(r.data)).catch((e) => alive && setError(e));
    return () => {
      alive = false;
    };
  }, [url]);
  return { data, error };
}
